import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferDigitalUploadQuery, OfferGameServiceUploadQuery } from './type';

/**
 * 上传数字商品offer
  POST /product/offerManage/insertDigitalOffer
  接口ID：263628557
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628557
 */
export const postOfferDigitalProductUpload = (data: OfferDigitalUploadQuery): AxiosPromise => {
  return request({
    url: '/product/offerManage/insertDigitalOffer',
    method: 'post',
    data
  });
};

/**
 * 上传game service offer
  POST /product/offerManage/insertGameServiceOffer
  接口ID：263628556
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628556
 */
export const postOfferGameServiceUpload = (data: OfferGameServiceUploadQuery): AxiosPromise => {
  return request({
    url: '/product/offerManage/insertGameServiceOffer',
    method: 'post',
    data
  });
};

/**
 * 上传offer图片校验
 * GET /product/offerManage/importOfferPicture
 */
export const getOfferPictureUploadCheck = (params: { spuId: string }): AxiosPromise => {
  return request({
    url: '/product/offerManage/importOfferPicture',
    method: 'get',
    params
  });
};
